import { inject, observer } from 'mobx-react'
import React from 'react'
import LayerWrapper from './Layers/LayerWrapper'
import GuideWrapper from './Layers/GuideWrapper'
import TextLayer from './Layers/TextLayer'

@inject('workAreaStore', 'layerStore') @observer
class Page extends React.Component {

  getTextInputWrapper(showText, textLayer, page, index){
    const { workAreaStore } = this.props
    if(showText && textLayer){
      const style = workAreaStore.getLayerStyle(textLayer)
      const pageEl = document.querySelector(`[data-id="${btoa(page.id)}"]`)
      const { xPos, yPos } = textLayer
      let t = pageEl.offsetTop
      let y = yPos
      return (
        <div 
          className='workarea__text-page'
          style={{
            width: textLayer.displayWidth + 'px',
            height: textLayer.displayHeight + 'px',
            position: 'absolute',
            top: t + yPos + 'px',
            left: xPos,

          }}
        >
          <div 
            className='workarea__text-page__text-wrapper'
            data-id={btoa(textLayer.id)}
            style={{
              position: 'absolute',
              ...style,
              transform: `translate(0px, 
              0px) ${style.transform ?
              style.transform : ""}`,
            }}
          >
            {
              <TextLayer {...textLayer} canSelect={true} />
            }
          </div>
        </div>
      )
    }
  }

  setActivePageCrop(type){
    this.props.workAreaStore.setActiveBackgroundCropper(type)
  }

  setActiveDot(type){
    this.props.workAreaStore.setActiveResizeDot(type)
  }

  render(){
    const { workAreaStore, layerStore, id, active, index } = this.props
    const page = workAreaStore.pages[index]
    const { zoom } = workAreaStore
    const zv = zoom / 100
    const layers = workAreaStore.getPageLayers(index)
    const marginValue = zv > 0.5 ? 100 * zv : 0
    let showText = false
    let textLayer = null
    if(workAreaStore.selectedLayer && workAreaStore.editingTextId){
      const existing = page.layers.find(({ id: lid }) => lid === workAreaStore.selectedLayer)
      if(existing){
        showText = true
        textLayer = existing
      }
    }
    const dotSize = 20 / (zoom / 100)
    return (
      <div style={{position: 'relative'}}>
        <div
          className={
            active ? 'workarea__page active' : 'workarea__page'
          }
          data-id={btoa(id)}
          style={{
            ...layerStore.getPageStyle(page, false, false, true),
            marginBottom: index === workAreaStore.pages.length - 1 ? marginValue + 'px' : '0'
          }}
        >
        <div className='workarea__page__filters' 
          style={{
            position: 'absolute',
            ...layerStore.getPageStyle(page, false, false, false, false, true),
            marginBottom: index === workAreaStore.pages.length - 1 ? marginValue + 'px' : '0'
          }}
        />
          {
            page.cropperOpen && page.backgroundUrl ? (
              <>
                <div className='workarea__page__cropper-overlay'
                  style={{
                    ...layerStore.getPageStyle(page),
                    marginBottom: index === workAreaStore.pages.length - 1 ? marginValue + 'px' : '0',
                    //background: 'rgba(0,0,0,0.5)',
                    position: 'absolute',
                    overflow: 'hidden',
                    zIndex: 1000
                  }}
                >
                  <img
                    className='workarea__page__cropper-image'
                    style={{
                      position: 'absolute',
                      ...workAreaStore.getPageBackgroundFullStyle(id)
                    }}
                    src={page.backgroundUrl}
                  />
                </div>
                <div
                  className='workarea__page__cropper'
                  data-id={btoa(id)}
                  style={{
                    position: 'absolute',
                    opacity: 0.5,
                    ...workAreaStore.getPageBackgroundFullStyle(id)
                  }}
                >
                  <img
                    draggable={false}
                    className='workarea__page__cropper-image'
                    style={{
                      width: '100%',
                      height: '100%'
                    }}
                    src={page.backgroundUrl}
                  />
                  <div
                    className={`workarea__page__cropper-dot upper-left `}
                    style={{
                      width: dotSize + 'px',
                      height: dotSize + 'px',
                      left: -1 * (dotSize / 2),
                      top: -1 * (dotSize / 2)
                    }}
                    onMouseDown={() => this.setActiveDot('topLeft')}
                  />
                  <div 
                    className='workarea__page__cropper-dot upper-right '
                    style={{
                      width: dotSize + 'px',
                      height: dotSize + 'px',
                      right: -1 * (dotSize / 2),
                      top: -1 * (dotSize / 2)
                    }}
                    onMouseDown={() => this.setActiveDot('topRight')}
                  />
                  <div 
                    className='workarea__page__cropper-dot bottom-right '
                    style={{
                      width: dotSize + 'px',
                      height: dotSize + 'px',
                      right: -1 * (dotSize / 2),
                      bottom: -1 * (dotSize / 2)
                    }}
                    onMouseDown={() => this.setActiveDot('bottomRight')}
                  />
                  <div 
                    className='workarea__page__cropper-dot bottom-left '
                    style={{
                      width: dotSize + 'px',
                      height: dotSize + 'px',
                      left: -1 * (dotSize / 2),
                      bottom: -1 * (dotSize / 2)
                    }}
                    onMouseDown={() => this.setActiveDot('bottomLeft')}
                  />
                </div>
              </>
            )
            :
            (
              <div 
                className='workarea__page__layers'
                data-id={btoa(id)}
                style={{
                  ...layerStore.getPageStyle(page, false, false, false, true),
                  marginBottom: index === workAreaStore.pages.length - 1 ? marginValue + 'px' : '0'
                }}
              >
                {
                  layers.map((layer, lIdx) => (
                    <LayerWrapper key={layer.id} layerIndex={lIdx} pageIndex={index} layer={layer} />
                  ))
                }
                <GuideWrapper pageWidth={page.displayWidth} pageHeight={page.displayHeight} pageIndex={index}/>
              </div>
            )
          }
        </div>
        {
          this.getTextInputWrapper(showText, textLayer, page, index)
        }
      </div>
    )
  }

}

export default Page